/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable camelcase */

var serverVars = require('server-vars');
var gtmDataLayer = require('./gtmDataLayer');
var Deferred = require('simply-deferred').Deferred;
var merge = require('deepmerge');
// After being compiled with webpack, merge functions are under merge.default
// Assign to merge.default after being compiled,
// leave as merge when running locally for tests
merge = typeof merge === 'function' ? merge : merge.default;

var undefined = void 0;

function isEmpty(value) {
    return value ? !Object.keys(value).length : true;
}

function pick(data, dataKeys) {
    var newObject = {};
    Object.keys(data).forEach(function(key) {
        if (dataKeys.indexOf(key) !== -1) {
            newObject[key] = data[key];
        }
    });
    return newObject;
}

function omit(data, dataKeys) {
    var newObject = {};
    Object.keys(data).forEach(function(key) {
        if (dataKeys.indexOf(key) === -1) {
            newObject[key] = data[key];
        }
    });
    return newObject;
}

/*
 *
 * SETUP 1STDIBS-SPECIFIC TRACKING HERE, DON'T PUT OUTSIDE DEPENDENCIES IN GAS.SETUP
 *
 */

// serverVars is undefined on legacy pages
// TODO: May have to do this for data layers
serverVars = serverVars || {};
var serverVarsTracking = serverVars.tracking;
var tracking = {};

// provide backward-compatibility for the legacy
// dibs.tracking.customVars array
if (serverVarsTracking) {
    tracking.customVars = serverVarsTracking.customVars || [];
}

// Boolean flags and methods used to ensure events are fired to Google Tag Manager in the correct order
// (see startTrackingEvents method description)
var gtmInitialInfoFired = false;
var gtmInitialPageViewFired = false;

var useShippingStatusData;
var shippingStatusDfd = Deferred();
var gtmEventQueue = [];
var gtmPageInfo = serverVars.get('tracking.initialDataLayerInfo') || {};
var gtmUserAttributeKeys = [
    'loginStatus',
    'registrationStatus',
    'userID',
    'guestID',
    'userEmail',
    'userEmailAddress',
    'emailToken',
    'userZip',
    'defaultCurrency',
    'firstSessionDate',
    'contactDealerStatus',
    'buyerStatus',
    'tradeStatus',
    'customerType',
    'tradeTier',
    'tradeFirmId',
    'profileStatus',
    'tradeRewardStatus',
    'registrationDate',
    'incomeRange',
    'currentAccountType',
    'mentionMeCiphertext',
    'mentionMeNonce',
    'hasGuestCheckout',
    'activePromotion',
];
var comCustomDimensionMap = {
    dimension1: 'timePeriod',
    dimension2: 'creator',
    dimension8: 'onSale',
    dimension9: 'newListing',
    dimension11: 'dealerName',
    dimension12: 'dealerID',
    dimension13: 'dealerLocation',
    dimension20: 'itemPostingLocation',
    dimension37: 'purchaseStatus',
    dimension38: 'askingPrice',
    dimension76: 'priceType',
    dimension83: 'contemporaryTrackingString',
};

var hasWindow = typeof window !== 'undefined';
var hasNewRelic = !!(hasWindow && window.newrelic);

function createStackTrace(msg) {
    var err = new Error(msg);
    if (typeof Error.captureStackTrace === 'function') {
        Error.captureStackTrace(err, createStackTrace);
    }
    if (err.stack) {
        return err.stack;
    }
    return err;
}

/**
 *
 * @param hookName string
 */
function nrLogging(hookName, args) {
    if (hasNewRelic && typeof window.newrelic.addPageAction === 'function') {
        window.newrelic.addPageAction('dibs-tracking:audit', {
            hookName: hookName,
            args: args,
            stack: createStackTrace(hookName + ' called'),
        });
    }
}

/**
 * For Google Tag Manager to work properly the order in which data is added to the dataLayer is important
 *  1. initial page data/user info
 *  2. initial page view event
 *  3. any ga events fired on the page
 * This is a private function which is called by either tracking.trackPageView or tracking.addUserAttributes and
 * controls this flow of how events are fired.
 * @private
 */
var startTrackingEvents = function() {
    // need to check that we aren't already tracking events so that forEach call
    // doesn't accidentally put us in an infinite loop
    if (gtmEventQueue === gtmDataLayer) {
        return;
    }

    // add each of the events in the queue to the gtmDataLayer (in fifo order)
    gtmEventQueue.forEach(function(event) {
        gtmDataLayer.push(event);
    });

    // change reference
    gtmEventQueue = gtmDataLayer;
};

/**
 * helper method used to parse a pdp url for an item's category level (L1/L2/L3), name and id
 * @param url
 * @returns {*}
 */
var ecomParseUrl = function(url) {
    if (typeof url !== 'string') {
        return {};
    }

    if (url.startsWith('https://')) {
        var noProto = url.split('https://')[1];
        url = noProto.slice(noProto.indexOf('/'));
    }

    // given a pdp url of the form -->
    //      /{L1}/{l2}/{L3}/{product name}/id-{item pk}/?{random params}
    // set pathArr to
    //      [path, {L1/L2/L3}, {L1}, {L2}, {L3}, {product name}, {item pk}]
    var pathArr = /^\/(?:([^\/]*)\/([^\/]*)(?:(?:\/([^\/]*)(?:\/([^\/]*)))|(?:\/([^\/]*))?))\/id-([^/]+)\/?$/i.exec(
        url
    );
    if (isEmpty(pathArr)) {
        return {};
    }
    // grab the item id, the product name and the uri substring for the categories
    return {
        category: [pathArr[1], pathArr[2], pathArr[3]]
            .filter(function(elem) {
                return !!elem;
            })
            .join('/'), // {L1/L2/L3}
        name: (pathArr[4] || pathArr[5] || '').split('-').join(' '),
        id: pathArr[6],
    };
};

/**
 * this helper function is used in tracking.trackPageView, tracking.trackSocial, and tracking.trackEvent
 * to merge additional data into the trackObject that is pushed to the dataLayer
 * @param gtmData
 * @param trackObj
 */
var mergeAdditionalData = function(gtmData, trackObj) {
    var additionalData = trackObj && trackObj.additional ? trackObj.additional : {};
    return merge(gtmData, additionalData);
};

/**
 * helper method (used in ecommerceProduct) that takes the trackObj products array and returns a product array
 * formatted for the GTM tracking object.
 * @param productArray
 * @returns {Array}
 */
var ecomGetProducts = function(productArray) {
    var outArr = [];
    var productData;
    if (productArray !== undefined && productArray.length) {
        productArray.forEach(function(product) {
            productData = merge(ecomParseUrl(product.url), product);
            productData = mergeAdditionalData(productData, product);
            productData = omit(productData, ['url', 'additional']);
            outArr.push(productData);
        });
    }
    return outArr;
};

/**
 * check for this value at run time instead of setting it once at run time
 * @returns {boolean}
 */
tracking.isGaAllowed = function() {
    nrLogging('isGaAllowed');
    // phpstorm says this condition can be simplified
    // but it makes it less readable IMO
    // return !(serverVars.settings && serverVars.settings.allowGa === false);
    // is what it like instead
    if (serverVars.settings && serverVars.settings.allowGa === false) {
        return false;
    }
    return true;
};

/**
 * pushes userAttributes into the dataLayer (along with the gtmPageInfo)
 * @param trackObj
 */
tracking.addUserAttributes = function addUserAttributes(trackObj) {
    nrLogging('addUserAttributes');
    var gtmUserAttributes;
    if (!isEmpty(trackObj) && !gtmInitialInfoFired) {
        // filters out invalid userAttribute keys
        gtmUserAttributes = pick(trackObj, gtmUserAttributeKeys);

        // Once the shipping status data is available, proceed setting attributes to the gtmDataLayer
        // If not using shipping status data, go forward and resolve the deferred object
        if (!useShippingStatusData) {
            shippingStatusDfd.resolve();
        }
        shippingStatusDfd.done(function(userQuoteData) {
            // pushing the initial dataLayerInfo directly to the dataLayer
            gtmDataLayer.push(merge.all([gtmUserAttributes, gtmPageInfo, userQuoteData || {}]));
            gtmInitialInfoFired = true;

            // if the pageView has not been fired then we want to wait for it to be fired to start tracking events
            if (gtmInitialPageViewFired) {
                startTrackingEvents();
            }
        });
    }
};

tracking.resetGTMPageView = function resetGTMPageView() {
    nrLogging('resetGTMPageView');
    gtmInitialPageViewFired = false;
    gtmEventQueue = [];
};

tracking.resetGtmTrackingInSamePageView = function resetGtmTrackingInSamePageView() {
    nrLogging('resetGtmTrackingInSamePageView');
    gtmInitialInfoFired = false;
    gtmPageInfo = serverVars.get('tracking.initialDataLayerInfo') || {};
};

/**
 * resets the google tag manager tracking by setting all the flags back to false, recreating the event queue
 * ** FOR TESTING **
 */
tracking.resetGtmTracking = function resetGtmTracking() {
    nrLogging('resetGtmTracking');
    this.resetGtmTrackingInSamePageView();
    this.resetGTMPageView();
};

/**
 * add/update aditional page info vars
 */
tracking.updateGtmPageInfo = function updateGtmPageInfo(trackingObj) {
    nrLogging('updateGtmPageInfo');
    gtmPageInfo = merge(gtmPageInfo, trackingObj || {});
};

/**
 * sets te google tag manager tracking flags to true and calls startTrackingEvents()
 * ** FOR TESTING **
 */
tracking.setGtmFlagsTrue = function setGtmFlagsTrue() {
    nrLogging('setGtmFlagsTrue');
    gtmInitialInfoFired = true;
    gtmInitialPageViewFired = true;
    startTrackingEvents();
};

/**
 * The main page view tracking call
 * @param {string || object} trackObj       Can either be the literal url or an object with a url key
 *                                          (can also be undefined in which case GTM will internally grab
 *                                          the url from the page)
 * @param {string} trackObj.url
 * @param {object} [trackObj.additional]    An object with any additional key/value pairs to pass to GTM
 *                                          added to gtmData in mergeAdditionalData(gtmData, trackObj)
 */
tracking.trackPageview = function trackPageview(trackObj) {
    nrLogging('trackPageview');
    var gtmData;

    // this is necessary for stale logins on checkout
    // so that the page view tracking doesn't fire twice
    if (tracking.isGaAllowed()) {
        gtmData = {
            event: 'e_ga_pageview',
            opt_pageURL: typeof trackObj === 'object' ? trackObj.url : trackObj,
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);
        gtmData.opt_pageURL = gtmData.opt_pageURL || undefined; // eslint-disable-line

        if (gtmData.opt_pageURL && /^https?/.test(gtmData.opt_pageURL)) {
            var parts = gtmData.opt_pageURL.split('/');
            // => ["https:", "", "www.1stdibs.com", "path", "segment"];
            // start from the 3rd index
            // safe to add a preceding slash here since there
            // is no empty string in the 3rd index to join with
            var path = '/' + parts.slice(3).join('/'); // => path/segment
            if (!/\/$/.test(path)) {
                // if path does NOT end in /, add it
                path = path + '/';
            }
            gtmData.opt_pageURL = path;
        }

        // If this is not the initial page view then just push it like a regular event
        if (gtmInitialPageViewFired) {
            gtmEventQueue.push(gtmData);

            // If it is the initial page view then add it to the beginning of the queue, switch flag
        } else {
            gtmEventQueue.unshift(gtmData);
            gtmInitialPageViewFired = true;

            // if the initial dataLayer info has not been added then we want to wait to start tracking events
            if (gtmInitialInfoFired) {
                startTrackingEvents();
            }
        }
    }
};

/**
 * Event tracking using Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.category    The tracking category - a way to group objects to track
 * @param {string} trackObj.action      The tracking action - typically the type of event or interaction
 * @param {string} [trackObj.label]     The tracking label - additional dimension to use for tracking
 * @param {number} [trackObj.value]     The tracking value
 * @param {boolean} [trackObj.noninteraction] Affects bounce rate (must be explicitly passed in to trigger a page view)
 *                                            - `true` (default) will not count as another page view which will mean if a user visits one page, interacts, and leaves, a bounce will be triggered (expected)
 *                                            - `false` will essentially treat the interaction as a page view and not trigger a bounce if the user leaves the page
 * @param {object} [trackObj.additional] An object with any additional key/value pairs to pass to GTM
 */
tracking.trackEvent = function trackEvent(trackObj) {
    var gtmData;
    if (!isEmpty(trackObj)) {
        trackObj.value = trackObj.value !== undefined ? trackObj.value : 0;
        trackObj.noninteraction =
            trackObj.noninteraction !== undefined ? trackObj.noninteraction : 1;

        gtmData = {
            event: 'e_ga_event',
            category: (trackObj.category || 'no category').toLowerCase(),
            action: trackObj.action || 'no action',
            label: trackObj.label || 'none',
            value: trackObj.value,
            noninteraction: trackObj.noninteraction,
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};
/**
 * Form Error tracking using Google Tag Manager
 * @param trackObj
 */
tracking.trackFormError = function(trackObj) {
    nrLogging('trackFormError');
    var gtmData;
    if (!isEmpty(trackObj)) {
        trackObj.value = trackObj.value !== undefined ? trackObj.value : 0;
        trackObj.noninteraction =
            trackObj.noninteraction !== undefined ? trackObj.noninteraction : 1;

        gtmData = {
            event: 'e_form_error',
            category: 'form error',
            action: trackObj.action || 'no action',
            label: trackObj.label || 'none',
            value: trackObj.value,
            noninteraction: trackObj.noninteraction,
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};

/**
 * Social tracking using Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.name            The social network name
 * @param {string} trackObj.event           The type of event it is firing
 * @param {object} [trackObj.additional]    An object with any additional key/value pairs to pass to GTM
 */
tracking.trackSocial = function trackSocial(trackObj) {
    nrLogging('trackSocial');
    var gtmData;

    if (trackObj.name && trackObj.event) {
        gtmData = {
            event: 'e_ga_social',
            network: trackObj.name,
            socialAction: trackObj.event,
            opt_target: trackObj.opt_target || undefined,
            opt_pagePath: trackObj.opt_pagePath || undefined,
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};

/**
 * Ecommerce Tracking used in Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.type            - productImpression/productClick/productDetail
 * @param {Array}  trackObj.products        - an array of objects, each containing one product's info
 *                                              {   url     : product url,
 *                                                  brand   : dealer id,
 *                                                  price   : USD price     ... }
 * @param {object} [trackObj.actionField]   - an object containing additional information specific to each tracking type
 *                                          { list : list,
 *                                            step : 1      ... }
 */
tracking.trackEcommerce = function ecommerceProduct(trackObj) {
    nrLogging('trackEcommerce');
    var products;
    var ecommerce = {};

    if (!isEmpty(trackObj) && trackObj.type) {
        products = ecomGetProducts(trackObj.products);
        switch (trackObj.type) {
            case 'productImpression':
                if (products.length) {
                    ecommerce.impressions = products;
                } else {
                    ecommerce = undefined;
                }
                break;
            case 'productClick':
                if (trackObj.actionField && trackObj.actionField.list && products.length) {
                    ecommerce.click = {
                        actionField: { list: trackObj.actionField.list },
                        products: products,
                    };
                }
                break;
            case 'productDetail':
                if (products.length) {
                    ecommerce.detail = { products: products };
                } else {
                    ecommerce = undefined;
                }
                break;
            case 'addToCart':
                if (products.length) {
                    ecommerce.add = { products: products };
                }
                break;
            case 'checkout':
                if (trackObj.actionField && trackObj.actionField.step && products.length) {
                    ecommerce.checkout = {
                        actionField: { step: trackObj.actionField.step },
                        products: products,
                    };
                    if (trackObj.option) {
                        ecommerce.checkout.option = trackObj.option;
                    }
                }
                break;
            case 'promotionImpression':
                if (trackObj.promotions && trackObj.promotions.length) {
                    ecommerce.promoView = { promotions: trackObj.promotions };
                }
                break;
            case 'promoClick':
                if (trackObj.promotions && trackObj.promotions.length) {
                    ecommerce.promoClick = { promotions: trackObj.promotions };
                }
                break;
        }
        // FINDING-8606 allow ecommerce === undefined because when ecommerce
        // is undefined it removes the event from the data layer. Which stops it from
        // being tracked on every vpv
        if (!isEmpty(ecommerce) || ecommerce === undefined) {
            gtmEventQueue.push({
                event: 'ecommerce_' + trackObj.type,
                ecommerce: ecommerce,
            });
        }
    }
};

/**
 * Maps the data values to the appropriate custom dimension indexes used by google analytics
 * (e.g. returns object { dimension1 : '1900s', dimension38 : '1000' } which ga will then map on their end
 * to 'timePeriod' and 'askingPrice' respectively).
 * @param   {object} data
 * @param   {array}  [dataKeys]         optional parameter to specify which specific keys in the
 *                                      data param should be tracked.
 * @returns {object} customDimensions
 */
tracking.getCustomDimensions = function(data, dataKeys) {
    nrLogging('getCustomDimensions');
    var customDimensions = {};

    if (data !== undefined) {
        // removes any key/values that are not wanted
        data = dataKeys ? pick(data, dataKeys) : data;

        // returns an object with the data object values associated with the correct dimension key
        var keys = Object.keys(comCustomDimensionMap);
        keys.forEach(function(key) {
            if (data[comCustomDimensionMap[key]] !== undefined) {
                customDimensions[key] = data[comCustomDimensionMap[key]];
            }
        });
    }

    return customDimensions;
};

/**
 * Ecommerce tracking function (specifically for tracking transactions)
 * This need to be sent to Google before userAttributes, gtmPageInfo or pageview is fired.
 * @param {object} trackObj
 * @param {array} trackObj.products
 * @param {object} trackObj.actionField
 */
tracking.trackEcommercePurchase = function(trackObj) {
    nrLogging('trackEcommercePurchase');
    var products = ecomGetProducts(trackObj.products);
    var ecommerce = {};

    if (trackObj.actionField && products.length) {
        ecommerce.purchase = {
            actionField: trackObj.actionField,
            products: products,
        };
    }

    if (!isEmpty(ecommerce)) {
        gtmDataLayer.push({
            event: 'ecommerce_' + trackObj.type,
            ecommerce: ecommerce,
        });
    }
};

tracking.addGTMMessage = function(message) {
    nrLogging('addGTMMessage');
    gtmDataLayer.push(message);
};

/**
 * AB test tracking
 * @param {object} abTestData An object containing
 * @param {string} abTestData.testGroup {control|variant}
 * @param {string} abTestData.additional {control|variant}
 * @param {string} [abTestData.additional.cdnTest1] string containing 'test_name - test_group'
 * @param {string} [abTestData.additional.cdnTest2] string containing 'test_name - test_group'
 * @param {string} [abTestData.additional.cdnTest3] string containing 'test_name - test_group'
 * @param {string} [abTestData.additional.sharedControl] fired to indicate control group
 * @param {string} pageContext contextual information to help filtering, such as 'pdp' or 'sb'
 */
tracking.trackAbTestEvent = function trackAbTestEvent(abTestData, pageContext) {
    nrLogging('trackAbTestEvent');
    if (!isEmpty(abTestData) && !isEmpty(abTestData.additional)) {
        this.trackEvent({
            category: 'a/b testing',
            action: pageContext, // GA treats 'action' like a sub-category for the purposes of AB test filtering
            label: abTestData.testGroup,
            additional: abTestData.additional,
        });
    }
};

/**
 * Used for tracking events that measure time. Mostly used for performance tracking.
 * @param {object} trackObj
 * @param {string} trackObj.metric - used to identify the timing event in GA. For e.g. `react hydrate`.
 * @param {number} [trackObj.duration] - miliseconds.
 * @param {number} [trackObj.startTime] - miliseconds.
 */
tracking.trackUserTiming = function trackEvent(trackObj) {
    var gtmData;
    if (!isEmpty(trackObj) && trackObj.var && typeof trackObj.value === 'number') {
        gtmData = {
            category: trackObj.category || trackObj.var,
            event: 'e_ga_user_timing',
            var: trackObj.var,
            value: trackObj.value,
            label: trackObj.label || 'none',
        };

        gtmEventQueue.push(gtmData);
    }
};

module.exports = tracking;
